export const CONTROL = 'control';
export const OFF = 'off';
export const ON = 'on';
export const USE_AMPLITUDE = process.env.NEXT_PUBLIC_USE_AMPLITUDE === 'true';
export const AMPLITUDE_API_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY ?? '';
export const AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY ?? '';
export const AMPLITUDE_ANALYTICS_PROXY_URL = process.env.NEXT_PUBLIC_ANALYTICS_PROXY_URL;
export const AMPLITUDE_EXPERIMENT_PROXY_URL = process.env.NEXT_PUBLIC_EXPERIMENT_PROXY_URL;
